import React from 'react';
import { colorSet } from '@components/Provider';
import { CustomizedTypography, CustomizedButton } from '@components/Customized';
import QuotationProgressPresenter from './QuotationProgressPresenter';
import { makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useReadRfqQuotationMutation } from '@generated/graphql';
import { useSelector } from '@store';
import { CommomRfqBubbleProps } from '@components/Chat/types';
import useDocuments from '@hooks/useDocuments';

const useStyles = makeStyles(() => {
  return {
    root: {
      width: 230,
      borderRadius: 10,
      backgroundColor: colorSet.gray000
    },
    header: {
      borderRadius: '10px 10px 0px 0px',
      padding: '10px 16px',
      color: colorSet.gray000,
      backgroundColor: colorSet.primary500
    },
    contentWrapper: {
      padding: '0px 16px 16px 16px'
    },
    content: {
      paddingTop: 16,
      borderTop: `1px solid ${colorSet.gray200}`
    },
    wordBreak: {
      wordBreak: 'break-all',
      '& b': {
        wordBreak: 'break-all'
      }
    },
    footer: {
      padding: 16
    }
  };
});

const AdjustedQuotationBubble = ({ chatMessage }: CommomRfqBubbleProps) => {
  const classes = useStyles();
  const history = useHistory();
  const rfqId = useSelector((state) => state.chat.rfqId);
  const partnerId = useSelector((state) => state.chat.quotationPartnerId);
  const { hasProgressingPayment, isOld, menuStatus } = useSelector(
    (state) => state.chat
  );
  const isTraking = !hasProgressingPayment && !isOld;
  const { onUpdateDocumentsCurrentId } = useDocuments();

  const [readQuotation] = useReadRfqQuotationMutation({
    variables: {
      input: {
        rfqId: rfqId ?? '',
        partnerId: partnerId ?? ''
      }
    }
  });

  const onClick = async () => {
    readQuotation();
    if (chatMessage?.rfq?.quotationId) {
      onUpdateDocumentsCurrentId({
        selectedQuotationId: chatMessage?.rfq?.quotationId ?? undefined
      });
    }

    return history.push(
      history.location.pathname + `?menu=quotation${isTraking ? '&p=1' : ''}`
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <CustomizedTypography variant="body2" fontWeight="bold" color="inherit">
          견적서
        </CustomizedTypography>
      </div>
      <QuotationProgressPresenter activeStep={1} />
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <CustomizedTypography
            variant="body1"
            fontWeight="bold"
            gutterBottoms={10}
          >
            견적서 도착
          </CustomizedTypography>
          <CustomizedTypography variant="body2" className={classes.wordBreak}>
            견적서를 확인하고 추가 수정 요청사항이 없다면 발주를 진행해주세요.
          </CustomizedTypography>
        </div>
      </div>
      <div className={classes.footer}>
        <CustomizedButton
          disabled={menuStatus?.quotation}
          variant="contained"
          color="primary"
          size="small"
          fullWidth
          onClick={onClick}
        >
          견적서 보기
        </CustomizedButton>
      </div>
    </div>
  );
};

export default AdjustedQuotationBubble;
